import { useRecordContext, useLoading } from "react-admin";
import { Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import CustomDateTimeInput from "server/components/Fields/CustomDateTimeInput";
import Declarations from "../components/Declarations";
import Ibans from "../components/Ibans";
import SpecialitiesList from "../components/SpecialitiesList";
import RankingsInput from "../components/RankingsInput";
import { CampaignSubTypes } from "utils/constants";
import NamesInput from "../components/Inputs/NamesInput";
import CitizenshipInput from "../components/Inputs/CitizenshipInput";
import DirectionInput from "../components/Inputs/DirectionInput";
import ChildCampaignInput from "../components/Inputs/ChildCampaignInput";
import Taxes from "../components/Taxes";
import AdmissionMarkerInput from "../components/Inputs/AdmissionMarkerInput";

const SaveForm = ({ isEdit }) => {
  const record = useRecordContext();
  const loading = useLoading();
  const { setValue } = useFormContext();
  const campaignIsStarted = record?.campaignIsStarted;

  const validateStartDate = (value, allValues) => {
    if (!value) {
      return "Полето е задължително";
    }
    if (value >= allValues.registrationTo) {
      return "Началната дата трябва да е по-малка от крайната";
    }
  };

  const validateEndDate = (value, allValues) => {
    if (!value) {
      return "Полето е задължително";
    }
    if (value <= allValues.registrationFrom) {
      return "Крайната дата трябва да е по-голяма от началната";
    }
  };

  const handleStartDateChange = value => {
    setMinEndDate(value?._i || null);
  };

  const [minEndDate, setMinEndDate] = useState(record?.registrationFrom);
  const [excludedSpecialityIds, setExcludedSpecialityIds] = useState(
    record?.specialityDtos?.map(s => s.specialityId).filter(Boolean) || [],
  );
  const [directionId, setDirectionId] = useState(record?.directionId || null);
  const [citizenshipIds, setCitizenshipIds] = useState(() => record?.citizenship || []);

  const citizenshipChange = event => {
    setCitizenshipIds(event.target.value);
  };

  const handleDirectionChange = newDirectionId => {
    setDirectionId(newDirectionId);
    setValue("specialityDtos", [{}]);
  };

  const handleSpecialityChange = (_event, formDataSpecialities) => {
    const selectedSpecialitiesIds = formDataSpecialities
      ? formDataSpecialities.map(item => item.specialityId).filter(Boolean)
      : [];
    setExcludedSpecialityIds(selectedSpecialitiesIds);
  };

  const handleRemoveSpeciality = removedId => {
    setExcludedSpecialityIds(prev => prev.filter(id => id !== removedId));
  };

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          {isEdit &&
            (campaignIsStarted ? (
              <Typography
                color={theme => theme.palette.success.main}
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                Кампанията е стартирала
              </Typography>
            ) : (
              <Typography
                color={theme => theme.palette.success.main}
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                Кампанията предстои да стартира
              </Typography>
            ))}
        </Grid>
        <Grid
          item
          xs={12}
        >
          <AdmissionMarkerInput readOnly={loading && isEdit} />
        </Grid>
        <Grid
          item
          xs={8}
        >
          <NamesInput readOnly={loading && isEdit} />
        </Grid>
        <Grid
          item
          xs={4}
        >
          <CitizenshipInput
            selectedIds={citizenshipIds}
            isArray
            isBgAndForeignersSeperated
            handleChange={citizenshipChange}
            readOnly={campaignIsStarted || (loading && isEdit)}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomDateTimeInput
            label="Начало на регистрация"
            source="registrationFrom"
            required={true}
            validate={validateStartDate}
            onChange={handleStartDateChange}
            readOnly={campaignIsStarted || (loading && isEdit)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <CustomDateTimeInput
            label="Край на регистрация"
            source="registrationTo"
            required={true}
            validate={validateEndDate}
            inputProps={{
              min: minEndDate,
            }}
            helperText={false}
            readOnly={loading && isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <DirectionInput
            required
            handleChange={handleDirectionChange}
            filterByUser
            filterOnlyForCampaigns
            readOnly={campaignIsStarted || (loading && isEdit)}
          />
        </Grid>
        {directionId && (
          <SpecialitiesList
            directionId={directionId}
            hasAvaliablePaidEducationCapacity={true}
            excludedSpecialityIds={excludedSpecialityIds}
            campaignIsStarted={campaignIsStarted}
            handleSpecialityChange={handleSpecialityChange}
            handleRemoveSpeciality={handleRemoveSpeciality}
            loading={loading && isEdit}
            isEdit={isEdit}
            showZvoCapacity={false}
          />
        )}
        <Declarations
          citizenshipIds={citizenshipIds}
          isDisabled={loading && isEdit}
        />
        <Taxes
          campaignSubTypeId={CampaignSubTypes.HospitalContract}
          citizenshipIds={citizenshipIds}
          specialityIds={excludedSpecialityIds || []}
          isCreate={!isEdit}
        />
        <RankingsInput isDisabled={loading && isEdit} />
        <Ibans isDisabled={loading && isEdit} />
        <Grid
          item
          md={5}
          xs={12}
        >
          <ChildCampaignInput
            childCampaignSubTypeId={CampaignSubTypes.Regular}
            required
            readOnly={campaignIsStarted || (loading && isEdit)}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default SaveForm;
